import { buildSubdomain } from '@/lib/domain';

/**
 * Page affichée lorsqu'un domaine externe (ex: www.maboutique.com) n'est
 * associé à AUCUNE boutique active. On n'affiche jamais une boutique au hasard
 * ni un tenant par défaut.
 */
export default function TenantNotFound() {
  const host =
    typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <header className="border-b border-background-200/70">
        <div className="max-w-6xl mx-auto px-4 md:px-6 h-14 md:h-16 flex items-center">
          <span className="text-lg font-bold font-heading text-foreground-950">Zifek</span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-md w-full text-center">
          <div className="w-16 h-16 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-5">
            <i className="ri-store-2-line text-3xl text-accent-600"></i>
          </div>

          <h1 className="text-2xl font-bold font-heading text-foreground-950 mb-2">
            Boutique introuvable
          </h1>
          <p className="text-sm text-foreground-500 leading-relaxed mb-1">
            Ce domaine n&apos;est pas encore configuré ou aucune boutique n&apos;y est associée.
          </p>
          {host && (
            <p className="text-xs text-foreground-400 font-mono mb-6 break-all">{host}</p>
          )}

          <div className="bg-background-100 border border-background-200/70 rounded-lg p-4 text-left mb-6">
            <p className="text-xs font-semibold text-foreground-700 mb-2 flex items-center gap-1.5">
              <i className="ri-information-line text-foreground-500"></i>
              Vous êtes le propriétaire de ce domaine ?
            </p>
            <p className="text-xs text-foreground-500 leading-relaxed">
              Connectez votre domaine depuis votre espace marchand Zifek, dans
              <span className="font-medium text-foreground-700"> Paramètres → Domaine</span>.
              Le sous-domaine gratuit reste toujours disponible :
            </p>
            <p className="text-xs text-foreground-700 mt-2 font-medium">
              {buildSubdomain('votre-boutique')}
            </p>
          </div>

          <a
            href="https://zifek.fr"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            Aller sur Zifek
          </a>
        </div>
      </main>

      <footer className="border-t border-background-200/70">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-4 text-center">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Zifek — La plateforme des commerçants
          </p>
        </div>
      </footer>
    </div>
  );
}